// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Permisos.css */

/* --- OrderList Cleanup --- */
.custom-orderlist .p-orderlist-controls {
    display: none !important;
}

.custom-orderlist .p-orderlist-header {
    display: none !important;
}

.custom-orderlist .p-orderlist-list {
    padding: 0.5rem !important;
    border: none !important;
    max-height: 60vh !important;
    background-color: transparent !important;
}

.custom-orderlist .p-orderlist-item {
    padding: 0 !important;
    margin-bottom: 0.75rem !important;
    background-color: transparent !important;
    color: inherit !important;
    border: none !important;
    border-radius: 8px !important;
}

.custom-orderlist .p-orderlist-item.p-highlight {
    background-color: transparent !important;
    color: inherit !important;
}

.custom-orderlist .p-orderlist-item:hover {
    background-color: transparent !important;
}

/* --- Role Card Styles --- */
.role-card {
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    transition: all 0.2s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    /* Ensure content stays inside */
}

.role-card:hover {
    border-color: var(--theme-primary);
    background-color: var(--theme-primary-soft);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.role-card.selected {
    border-color: var(--theme-primary);
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
    box-shadow: var(--shadow-sm);
    transform: translateX(5px);
}

.role-card.selected * {
    color: #ffffff !important;
}

.role-card.selected .pi-shield {
    color: #ffffff !important;
}


.role-icon-container {
    background: var(--bg-page);
    color: var(--theme-primary);
    transition: all 0.2s ease;
}

.role-card.selected .role-icon-container {
    background: rgba(255, 255, 255, 0.2) !important;
    color: #ffffff !important;
}

.role-card.locked {
    background: var(--bg-page);
    border-color: var(--border-color);
    opacity: 0.8;
    /* Keep fully visible but distinct */
}

/* --- Layout fix helpers --- */
.role-list-container {
    padding-right: 1rem;
    height: 100%;
    overflow-y: auto;
}

.permissions-container {
    height: 100%;
    border-left: 1px solid var(--surface-border);
    padding-left: 1.5rem;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
    .role-list-container {
        padding-right: 0;
        border-right: none;
        margin-bottom: 2rem;
    }

    .permissions-container {
        border-left: none;
        padding-left: 0;
        border-top: 1px solid var(--surface-border);
        padding-top: 1.5rem;
    }
}

/* --- Permission Checkbox Card --- */
.permission-checkbox-card {
    background-color: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 6px;
    transition: background-color 0.2s;
}

.permission-checkbox-card:hover {
    background-color: var(--theme-primary-soft);
}

.permission-checkbox-card.active {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
    border-color: var(--theme-primary);
    box-shadow: var(--shadow-sm);
}

.permission-checkbox-card.active label {
    color: #ffffff !important;
}

.permission-checkbox-card.active .p-checkbox .p-checkbox-box {
    border-color: #ffffff;
    background: #ffffff;
}

.permission-checkbox-card.active .p-checkbox .p-checkbox-box .p-checkbox-icon {
    color: var(--theme-primary);
}


.permission-checkbox-card.disabled {
    opacity: 0.7;
    pointer-events: none;
}

/* --- Action Buttons Pulido --- */
.btn-new-role {
    background: var(--theme-primary) !important;
    border: none !important;
    color: #ffffff !important;
}

.btn-new-role .p-button-label,
.btn-new-role .p-button-icon {
    color: #ffffff !important;
}

.role-card .p-button.text-blue-600 {
    color: var(--theme-primary) !important;
}

.role-card .p-button.text-gray-700 {
    color: #dc3545 !important;
    /* Rojo para eliminar */
}`, "",{"version":3,"sources":["webpack://./src/pages/Permisos.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB,8BAA8B;AAC9B;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,wCAAwC;IACxC,yBAAyB;IACzB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA,6BAA6B;AAC7B;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;IAC3C,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,4FAA4F;IAC5F,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,YAAY;IACZ,oCAAoC;AACxC;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,4CAA4C;IAC5C,oBAAoB;AACxB;;AAEA,2BAA2B;AAC3B;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,2CAA2C;QAC3C,mBAAmB;IACvB;AACJ;;AAEA,qCAAqC;AACrC;IACI,gCAAgC;IAChC,qCAAqC;IACrC,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4FAA4F;IAC5F,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA,kCAAkC;AAClC;IACI,2CAA2C;IAC3C,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B","sourcesContent":["/* Permisos.css */\n\n/* --- OrderList Cleanup --- */\n.custom-orderlist .p-orderlist-controls {\n    display: none !important;\n}\n\n.custom-orderlist .p-orderlist-header {\n    display: none !important;\n}\n\n.custom-orderlist .p-orderlist-list {\n    padding: 0.5rem !important;\n    border: none !important;\n    max-height: 60vh !important;\n    background-color: transparent !important;\n}\n\n.custom-orderlist .p-orderlist-item {\n    padding: 0 !important;\n    margin-bottom: 0.75rem !important;\n    background-color: transparent !important;\n    color: inherit !important;\n    border: none !important;\n    border-radius: 8px !important;\n}\n\n.custom-orderlist .p-orderlist-item.p-highlight {\n    background-color: transparent !important;\n    color: inherit !important;\n}\n\n.custom-orderlist .p-orderlist-item:hover {\n    background-color: transparent !important;\n}\n\n/* --- Role Card Styles --- */\n.role-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    /* Ensure content stays inside */\n}\n\n.role-card:hover {\n    border-color: var(--theme-primary);\n    background-color: var(--theme-primary-soft);\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.role-card.selected {\n    border-color: var(--theme-primary);\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n    box-shadow: var(--shadow-sm);\n    transform: translateX(5px);\n}\n\n.role-card.selected * {\n    color: #ffffff !important;\n}\n\n.role-card.selected .pi-shield {\n    color: #ffffff !important;\n}\n\n\n.role-icon-container {\n    background: var(--bg-page);\n    color: var(--theme-primary);\n    transition: all 0.2s ease;\n}\n\n.role-card.selected .role-icon-container {\n    background: rgba(255, 255, 255, 0.2) !important;\n    color: #ffffff !important;\n}\n\n.role-card.locked {\n    background: var(--bg-page);\n    border-color: var(--border-color);\n    opacity: 0.8;\n    /* Keep fully visible but distinct */\n}\n\n/* --- Layout fix helpers --- */\n.role-list-container {\n    padding-right: 1rem;\n    height: 100%;\n    overflow-y: auto;\n}\n\n.permissions-container {\n    height: 100%;\n    border-left: 1px solid var(--surface-border);\n    padding-left: 1.5rem;\n}\n\n/* Responsive adjustments */\n@media screen and (max-width: 768px) {\n    .role-list-container {\n        padding-right: 0;\n        border-right: none;\n        margin-bottom: 2rem;\n    }\n\n    .permissions-container {\n        border-left: none;\n        padding-left: 0;\n        border-top: 1px solid var(--surface-border);\n        padding-top: 1.5rem;\n    }\n}\n\n/* --- Permission Checkbox Card --- */\n.permission-checkbox-card {\n    background-color: var(--bg-card);\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    transition: background-color 0.2s;\n}\n\n.permission-checkbox-card:hover {\n    background-color: var(--theme-primary-soft);\n}\n\n.permission-checkbox-card.active {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n    border-color: var(--theme-primary);\n    box-shadow: var(--shadow-sm);\n}\n\n.permission-checkbox-card.active label {\n    color: #ffffff !important;\n}\n\n.permission-checkbox-card.active .p-checkbox .p-checkbox-box {\n    border-color: #ffffff;\n    background: #ffffff;\n}\n\n.permission-checkbox-card.active .p-checkbox .p-checkbox-box .p-checkbox-icon {\n    color: var(--theme-primary);\n}\n\n\n.permission-checkbox-card.disabled {\n    opacity: 0.7;\n    pointer-events: none;\n}\n\n/* --- Action Buttons Pulido --- */\n.btn-new-role {\n    background: var(--theme-primary) !important;\n    border: none !important;\n    color: #ffffff !important;\n}\n\n.btn-new-role .p-button-label,\n.btn-new-role .p-button-icon {\n    color: #ffffff !important;\n}\n\n.role-card .p-button.text-blue-600 {\n    color: var(--theme-primary) !important;\n}\n\n.role-card .p-button.text-gray-700 {\n    color: #dc3545 !important;\n    /* Rojo para eliminar */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
